import { Component, h } from '@stencil/core';
import state from '@ugc-store';
import { toLocalSeparator } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-review-global-title',
  shadow: false,
})
export class UgcReviewGlobalTitle {
  render() {
    const {
      reviewStaticLanguage: { IDS_GLOBAL_REVIEWS = '' } = {},
      ids,
      reviewTotalCount,
      isShowReviewSkeleton,
      isDesktop,
    } = state;
    if (isShowReviewSkeleton) return null;
    if (!ids.length) return null;
    return (
      <div class={`flex-row-start-center ${isDesktop ? 'fs-20' : 'fs-16'}  bold color-gray-700 gap-4`}>
        <span>{IDS_GLOBAL_REVIEWS}</span>
        <span>({toLocalSeparator(reviewTotalCount)})</span>
      </div>
    );
  }
}
